export const ALL_MONTHS = 0;

export interface IReportPeriod {
  month: number;
  year: number;
}

export interface IReportRevenueItem {
  name: string;
  fullName: string;
  revenue: number;
  ticketCount: number;
}

export interface IRankingItem {
  id: number | string;
  name: string;
  parkName?: string;
  revenue: number;
  ticketCount: number;
}

export const buildFullNameMap = (
  items: { name: string; fullName: string }[],
): Record<string, string> =>
  items.reduce((acc, item) => ({ ...acc, [item.name]: item.fullName }), {});
